import { useTranslation } from "react-i18next";
import Card from "../../common/components/Card";
import DataTable, { customCtrlTypeSupported } from "../../common/components/DataTable";
import { Container } from "../../common/components/Grid";
import { useEpcrAllergyDefs } from "../../reducers/epcrAllergySlice";
import { useEpcrHistoryDefs } from "../../reducers/epcrHistorySlice";
import { useEpcrMedicationDefs } from "../../reducers/epcrMedicationSlice";
import PropTypes from 'prop-types';
import { useEpcrEditorEpcr, useEpcrEditorHistory, useEpcrEditorIntent } from "./EpcrContext";
import useClientConfig from "../../common/hooks/clientConfigHook";
import CustomForm from "../../common/components/CustomForm";
import { useCallback, useMemo } from "react";
import { deepClone } from "../../common/utils/objectUtilities";

const EpcrHistory = ({ disabled = false }) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const { epcr, update } = useEpcrEditorEpcr();
    const { history, meds, allergies, addHistory, removeHistory, addMedication, removeMedication, addAllergy, removeAllergy } = useEpcrEditorHistory();
    const intent = useEpcrEditorIntent();
    const historyDefs = useEpcrHistoryDefs();
    const medicationDefs = useEpcrMedicationDefs();
    const allergyDefs = useEpcrAllergyDefs();

    const runUpdate = useCallback((field, value) => {
        update(field, value);
    }, [update]);

    let historyColumns = [{field: "history", editable: false, type: "datalabel"}];
    let historyFooterColumns = [{field: "history", required: true, editable: true, type: "typeahead", suggestions: historyDefs.map(h => h.name), maxlength: 256, label: t('newHistoryEntry')}];
    let medicationColumns = [{field: "medication", editable: false, type: "datalabel"}];
    let medicationFootercolumns = [{field: "medication", required: true, editable: true, type: "typeahead", suggestions: medicationDefs.map(m => m.name), maxlength: 256, label: t('newMedicationEntry')}];
    let allergyColumns = [{field: "allergy", editable: false, type: "datalabel"}];
    let allergyFooterColumns = [{field: "allergy", required: true, editable:true, type: "typeahead", suggestions: allergyDefs.map(a => a.name), maxlength: 256, label: t('newAllergyEntry')}];

    const def = useMemo(() => {
        if (intent === 'search' && clientConfig.epcrHistoryFormSpec) {
            let def = deepClone(clientConfig.epcrHistoryFormSpec);
            def.forEach(section => {
                section.rows = section.rows.map(row => row.filter(cell => customCtrlTypeSupported(cell)));
                section.rows = section.rows.filter(row => row.length > 0);
            });
            def = def.filter(section => section.rows.length > 0);
            return def;
        }
        return clientConfig.epcrHistoryFormSpec;
    }, [intent, clientConfig.epcrHistoryFormSpec]);

    return <Container fluid>
        <Card title={t('pastMedicalHistory')}>
            <DataTable disabled={disabled} defaultSort={[]} hideHeader={true} value={history} columns={historyColumns} footerColumns={historyFooterColumns} onAdd={addHistory} onRemove={removeHistory}></DataTable>
        </Card>

        <Card title={t('medication', { count: 100 })}>
            <DataTable disabled={disabled} defaultSort={[]} hideHeader={true} value={meds} columns={medicationColumns} footerColumns={medicationFootercolumns} onAdd={addMedication} onRemove={removeMedication}></DataTable>
        </Card>

        <Card title={t('allergy', {count: 100})}>
            <DataTable disabled={disabled} defaultSort={[]} hideHeader={true} value={allergies} columns={allergyColumns} footerColumns={allergyFooterColumns} onAdd={addAllergy} onRemove={removeAllergy}></DataTable>
        </Card>
        {clientConfig.epcrHistoryFormSpec && <CustomForm disabled={disabled} hideLabel={true} def={def} data={epcr?.customfields ?? {}} onChange={v => runUpdate('customfields', v)}></CustomForm>}
    </Container>
}

EpcrHistory.propTypes = {
    disabled: PropTypes.bool
}

export default EpcrHistory;